import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import moment from 'moment';

import { getTransactionsByFilter } from 'data/transactions/selectors';
import { getFieldString } from 'data/transactions/searchFilter';
import { formatNumber } from 'components/QuickenControls/AmountField';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CalHeaderMonth from './CalHeaderMonth';
import CalHeaderWeekDays from './CalHeaderWeekDays';
import CalDay from './CalDay';


const styles = () => ({
  days: {
    background: 'white',
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: -1,
    borderWidth: 4,
    border: 'solid',
    marginBottom: 4,
  },
});

class TransactionMonth extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      curMonth: {},
      monthTxs: null,
    };

  }

  componentDidMount() {
    this.createState(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.createState(nextProps, true);
  }


  createState = (props) => {
    const curMonth =
      props.year && props.month
        ? `${props.year}-${props.month}`
        : moment().format('YYYY-MM');

    const monthTxs = props.transactions.filter((x) => moment(x.postedOn).format('YYYY-MM') === curMonth);

    this.setState(
      {
        curMonth: {
          date: curMonth,
          name: moment(curMonth).format('MMMM YYYY'),
          days: moment(curMonth).daysInMonth(),
        },
        monthTxs,
      },
    );
  };

  onNextMonth = () => {
    this.updateState(moment(this.state.curMonth.date).add(1, 'M'));
  };
  onPrevMonth = () => {
    this.updateState(moment(this.state.curMonth.date).subtract(1, 'M'));
  };
  updateState = (newMonth) => {
    this.createState({ ...this.props, year: newMonth.format('YYYY'), month: newMonth.format('MM') });
  };

  onItemClick = (id) => {
    if (this.props.navFn) {
      this.props.navFn(this.state.monthTxs.get(id));
    }
  };

  buildDays = () => {
    const days = [];
    const props = {
    };

    for (let i = 1; i <= this.state.curMonth.days; i++) {
      const date = `${this.state.curMonth.date}-${(`0${i}`).slice(-2)}`; // Add leading zeros
      props.date = date;
      props.day = i;
      props.labels = [];

      if (i === 1) {
        props.firstDayIndex = moment(date)
          .startOf('month')
          .format('d');
      } else {
        delete props.firstDayIndex;
      }

      const dayTxs = this.state.monthTxs.filter((x) => moment(x.postedOn).get('date') === i);
      dayTxs.forEach((x) => {
        const inflow = x.amount > 0;
        let color = '#777';
        let fontWeight = 200;

        switch (true) {
          case (x.amount < -1000):
            color = '#300';
            fontWeight = 800;
            break;
          case (x.amount < -500):
            color = '#000';
            fontWeight = 600;
            break;
          case (x.amount < -200):
            color = '#222';
            fontWeight = 400;
            break;
          case (x.amount < -100):
            color = '#444';
            break;
          case (x.amount < -50):
            color = '#666';
            break;
          default:
            break;
        }

        const tooltip = `${x.payee} | ${getFieldString('category', x, false)} | ${getFieldString('amount', x, false)}`;

        props.labels.push({
          key: x.id,
          label1: x.payee,
          label2: formatNumber(x.amount, 'USD', '0,00.00'),
          tooltip,
          style: {
            color: inflow ? 'green' : color,
            fontWeight: inflow ? 800 : fontWeight,
          },
        });
      });

      days.push(
        <CalDay
          key={i}
          onItemClick={this.onItemClick}
          {...props}
        />
      );
    }
    return days;
  };

  render() {

    const { classes } = this.props;

    const weekdays = moment.weekdays();
    const days = this.buildDays();

    return (
      <div>
        <CalHeaderMonth
          curMonth={this.state.curMonth}
          onNextMonth={this.onNextMonth}
          onPrevMonth={this.onPrevMonth}
        />
        <CalHeaderWeekDays days={weekdays} />
        <div className={classes.days}>{days}</div>
      </div>
    );
  }
}

TransactionMonth.propTypes = {
  year: PropTypes.string,
  month: PropTypes.string,
  navFn: PropTypes.func,

  classes: PropTypes.object,
  transactions: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  return {
    transactions: getTransactionsByFilter(
      state,
      {
        accountIdsArray: ownProps.accountIds,
      }
    ),
  };
}

function mapDispatchToProps() {
  return {
  };
}


export default compose(
  withStyles(styles, {withTheme: true}),
  connect(mapStateToProps, mapDispatchToProps),
)(TransactionMonth);

